import React, { useState, Fragment, useContext } from 'react';
import './Screens.scss';
import { AppContext } from "../../Context/AppContext";
// Material UI
import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
// Custom Plugins
import { customCloneDeep } from '../../Plugins/HelperFunctions';

const Screen4 = () => {
  const { screensData, setScreensData, setActiveScreen, setShowSnackbar, setSnackbarMessage, setActiveFocus } = useContext(AppContext);
  const [screen4, setScreen4] = useState(screensData.screen4);

  const handleChange = (e) => {
    let { name, value } = e.target;
    let errorName = `${name}Error`

    if (value === '' || value === undefined || value.length !== 17) {
      setScreen4({
        ...screen4,
        [name]: value,
        [errorName]: true
      });
    } else {
      setScreen4({
        ...screen4,
        [name]: value,
        [errorName]: false
      });
    }
  };

  const handleNext = () => {
    if (screen4.vin && !screen4.vinError) {
      let clonedScreensData = customCloneDeep(screensData);
      clonedScreensData.screen1 = { ...screensData.screen1, vin: screen4.vin };
      clonedScreensData.screen4 = screen4;
      setScreensData(clonedScreensData);

      setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);

    } else {
      setScreen4({
        ...screen4,
        vinError: true,
      })
      setShowSnackbar(true);
      setSnackbarMessage('All required fields are not filled correctly.');
    }
  }

  const handlePrevious = () => {
    setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  }


  return (
    <Fragment>
      <div className="screen screenHeight">
        <form>
          <Box className="screen__wrapper" >
            <FormControl fullWidth>
              <TextField
                label="Vin"
                variant="outlined"
                name="vin"
                value={screen4.vin}
                error={screen4.vinError}
                helperText={`${screen4.vinError ? 'Invalid VIN or VIN not found. Note: VIN must be 17 characters long.' : ''}`}
                onFocus={() => setActiveFocus('vin')}
                onChange={handleChange}
              />
            </FormControl>

            <Alert severity="info">Since you do not have the title, we require your VIN for pickup. The VIN can be found on the vehicle or on its registration.</Alert>
          </Box>
        </form>
      </div>

      <Box className="screenBtnContainer" sx={{ pt: 4 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handlePrevious}
        >
          Previous
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

export default Screen4;
